import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './MobileNav.css';

function MobileNav({ isOpen, onClose, user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Close menu when clicking outside or pressing Escape
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      // Prevent body scroll when menu is open
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);

  const handleNavigate = (path) => {
    navigate(path);
    onClose();
  };

  const handleLogout = () => {
    onLogout();
    onClose();
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Backdrop */}
      {isOpen && (
        <div 
          className="mobile-nav-backdrop" 
          onClick={onClose}
          aria-hidden="true"
        />
      )}

      {/* Navigation Drawer */}
      <nav className={`mobile-nav ${isOpen ? 'open' : ''}`} role="navigation">
        <div className="mobile-nav-header">
          <button 
            className="mobile-nav-close" 
            onClick={onClose}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>

        {/* User Info */}
        <div className="mobile-nav-user">
          <div className="user-avatar">
            {user?.username?.charAt(0).toUpperCase() || '?'}
          </div>
          <div className="user-info">
            <div className="user-name">{user?.username || 'Guest'}</div>
            <div className="user-status">
              <span className="status-indicator online"></span>
              Online
            </div>
          </div>
        </div>

        {/* Navigation Items */}
        <div className="mobile-nav-items">
          <button
            className={`mobile-nav-item ${isActive('/') ? 'active' : ''}`}
            onClick={() => handleNavigate('/')}
          >
            <span className="nav-icon">🏠</span>
            <span className="nav-label">Dashboard</span>
          </button>

          <button
            className={`mobile-nav-item ${isActive('/squads') ? 'active' : ''}`}
            onClick={() => handleNavigate('/squads')}
          >
            <span className="nav-icon">👥</span>
            <span className="nav-label">Manage Squads</span>
          </button>

          <button
            className={`mobile-nav-item ${isActive('/settings') ? 'active' : ''}`}
            onClick={() => handleNavigate('/settings')}
          >
            <span className="nav-icon">⚙️</span>
            <span className="nav-label">Settings</span>
          </button>

          <div className="mobile-nav-divider"></div>

          <button
            className="mobile-nav-item"
            onClick={() => {
              window.open('https://github.com/yourusername/fpstak', '_blank');
              onClose();
            }}
          >
            <span className="nav-icon">ℹ️</span>
            <span className="nav-label">About</span>
          </button>

          <button
            className="mobile-nav-item logout"
            onClick={handleLogout}
          >
            <span className="nav-icon">🚪</span>
            <span className="nav-label">Logout</span>
          </button>
        </div>

        {/* Version Info */}
        <div className="mobile-nav-footer">
          <div className="app-version">FPSTAK v1.0</div>
        </div>
      </nav>
    </>
  );
}

export default MobileNav;

